module.exports = __webpack_public_path__ + "img/connect-ncp.cc36ae4c.png";